<template>
    <div class="container-fluid px-3">
        <div class="row">
            <div class="col-md-12">
                <div class="row bg-white">
                    <div class="col-md-12 pt-2 pb-2" style="font-size: 18px;">
                    <!--<i class="el-icon-office-building"></i>--> BUSINESS UNIT DETAIL - PLANT {{ plantno }}
                    </div>
                </div>
                
                <div class="row">
                    <div class="col-md-12 px-0">
                        <el-tabs v-model="activeName" @tab-click="handleTabClick">
                            <el-tab-pane name="first">
                                <span slot="label"><i class="el-icon-office-building"></i> General Info</span>
                                <div class="px-2 tab-container-item" :style="{ 'height': screenHeight + 'px' }">
                                    <div class="mb-4" v-for="item in units" :key="item.Id">
                                        <el-descriptions :title="item.Label" :column="1" :size="'medium'" border>
                                            <el-descriptions-item>
                                                <template slot="label">
                                                    {{ item.Prefix }} Id
                                                </template>
                                                {{ item.Id }}
                                            </el-descriptions-item>
                                            <el-descriptions-item>
                                                <template slot="label">
                                                    {{ item.Prefix }} Name
                                                </template>
                                                {{ item.UnitName }}
                                            </el-descriptions-item>
                                            <el-descriptions-item>
                                                <template slot="label">
                                                    Sales Area
                                                </template>
                                                {{ item.SalesArea }}
                                            </el-descriptions-item>
                                            <el-descriptions-item v-if="false">
                                                <template slot="label">
                                                    BUH
                                                </template>
                                                -
                                            </el-descriptions-item>
                                            <el-descriptions-item>
                                                <template slot="label">
                                                    Address
                                                </template>
                                                {{ item.Address }}
                                            </el-descriptions-item>
                                            
                                        </el-descriptions>                                          
                                    </div>        
                                    <Loader v-if="loading.plant"/>                                  
                                </div>
                            </el-tab-pane>
                            <el-tab-pane name="tab-map">
                                <span slot="label"><i class="el-icon-map-location"></i> Map</span>
                                <div class="px-2 tab-container-item" :style="{ 'height': screenHeight + 'px' }">
                                    <div class="mb-3">
                                        <MapView :stationdetail="stationdetail" :location="location"/>
                                    </div>

                                    <div>
                                        <MapStreetViewPanorama :stationdetail="stationdetail" :location="location"/>
                                    </div>

                                    <Loader v-if="loading.plant"/>
                                </div>
                            </el-tab-pane>
                            <el-tab-pane name="tab-sales-fuel" v-if="salestabshow.fuel">
                                <span slot="label"><i class="el-icon-s-data"></i> Sales Fuel</span>
                                <div class="px-2 tab-container-item" :style="{ 'height': screenHeight + 'px' }">
                                    <SalesFuel :plant="plantno" :station="stationid" :unitids="ids" :showchartfuel="showchartfuel"/>
                                    <Loader v-if="loading.plant"/>
                                </div>
                            </el-tab-pane>
                            <el-tab-pane name="tab-sales-store" v-if="salestabshow.store">
                                <span slot="label"><i class="el-icon-s-data"></i> Sales Store</span>
                                <div class="px-2 tab-container-item" :style="{ 'height': screenHeight + 'px' }">
                                    <SalesBrightStore :plant="plantno" :branchid="storeid" :showchartstore="showchartstore"/>
                                    <Loader v-if="loading.plant"/>
                                </div>
                            </el-tab-pane>
                            <el-tab-pane name="tab-sales-cafe" v-if="salestabshow.cafe">
                                <span slot="label"><i class="el-icon-s-data"></i> Sales Cafe</span>
                                <div class="px-2 tab-container-item" :style="{ 'height': screenHeight + 'px' }">
                                    <SalesBrightCafe :plant="plantno" :branchid="cafeid" :showchartcafe="showchartcafe"/>
                                    <Loader v-if="loading.plant"/>
                                </div>
                            </el-tab-pane>

                            <el-tab-pane name="tab-sales-lpg" v-if="salestabshow.lpg">
                                <span slot="label"><i class="el-icon-s-data"></i> Sales DC LPG</span>
                                <div class="px-2 tab-container-item" :style="{ 'height': screenHeight + 'px' }">
                                    <SalesBrightStore :plant="plantno" :branchid="lpgid" :showchartstore="showchartlpg"/>
                                    <Loader v-if="loading.plant"/>
                                </div>
                            </el-tab-pane>
                        
                            <el-tab-pane name="tab-sales-property-management">
                                <span slot="label"><i class="fas fa-cubes" aria-hidden="true"></i> Property Management</span>
                                <div class="px-2 tab-container-item" :style="{ 'height': screenHeight + 'px' }">
                                    <DataPropertyManagement :plant="plantno" :station="stationid" :ids="ids" :showchartproman="showchartproman"/>
                                    <Loader v-if="loading.plant"/>
                                </div>
                            </el-tab-pane>
                        
                            <el-tab-pane name="tab-asset">
                                <span slot="label"><i class="el-icon-s-platform"></i> Asset</span>
                                <div class="px-2 tab-container-item" :style="{ 'height': screenHeight + 'px' }">
                                    <DataAsset :plant="plantno" :unitids="ids"/>
                                    <Loader v-if="loading.plant"/>
                                </div>
                            </el-tab-pane>
                            <el-tab-pane name="tab-pegawai">
                                <span slot="label"><i class="el-icon-user-solid"></i> Pegawai</span>
                                <div class="px-2 tab-container-item" :style="{ 'height': screenHeight + 'px' }">
                                    <DataPegawai :plant="plantno" :unitids="ids"/>
                                    <Loader v-if="loading.plant"/>
                                </div>
                            </el-tab-pane>
                        
                            <el-tab-pane name="tab-pl-unit">
                                <span slot="label"><i class="el-icon-data-line"></i> PL Unit</span>
                                <div class="px-2 tab-container-item" :style="{ 'height': screenHeight + 'px' }">
                                    <DataPLUnit :plant="plantno" :station="stationid" :unitids="ids" :fuelcostcenters="fuelcostcenters" :nonfuelcostcenters="nonfuelcostcenters" :costcenters="costcenters" :showchartplunit="showchartplunit"/>
                                    <Loader v-if="loading.plant"/>
                                </div>
                            </el-tab-pane>
                            <!--
                            <el-tab-pane name="tab-post-mortem" v-if="false">
                                <span slot="label"><i class="el-icon-s-platform"></i> Post Mortem</span>
                                <div class="px-2 tab-container-item" :style="{ 'height': screenHeight + 'px' }">
                                    Post Mortem
                                    <Loader v-if="loading.plant"/>
                                </div>
                            </el-tab-pane>
                        -->
                        </el-tabs>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import Fuel from '@/components/page/Fuel.js'
import PetaGmap from '@/components/map/gmap.vue'
import { Rainbow, FuelColor, AxiosWithJar, Config} from '@/utility.js'
import Loader from '@/components/loader/Loader2.vue'
import ReportResultTable from '@/views/pages/ReportResultTable2.vue'
import LineChart from '@/components/chart/LineChart.js'
import BarChart from '@/components/chart/BarChart.js'
import $ from 'jquery';

import SalesFuel from '@/views/pages/BusinessUnit/Component/SalesFuel.vue'
import SalesBrightStore from '@/views/pages/BusinessUnit/Component/SalesBrightStore.vue'
import SalesBrightCafe from '@/views/pages/BusinessUnit/Component/SalesBrightCafe.vue'
import DataPegawai from '@/views/pages/BusinessUnit/Component/DataPegawai.vue'
import DataAsset from '@/views/pages/BusinessUnit/Component/DataAsset.vue'
import DataPLUnit from '@/views/pages/BusinessUnit/Component/DataPLUnit.vue'
import DataPropertyManagement from '@/views/pages/BusinessUnit/Component/DataPropertyManagement.vue'
import MapView from '@/views/pages/BusinessUnit/Component/MapView.vue'
import MapStreetViewPanorama from '@/views/pages/BusinessUnit/Component/MapStreetViewPanorama.vue'


export default
{
	extends: Fuel,
	components: { 
        SalesFuel,
        SalesBrightStore,
        SalesBrightCafe,

        DataPegawai,
        DataAsset,
        DataPLUnit,
        DataPropertyManagement,

        //ReportResultTable,
		MapView,
        MapStreetViewPanorama,
		Loader,
        //LineChart,
		//BarChart,
	},

	data() {
		return {
            ids: [],
			plantno: this.$route.query.plant ? this.$route.query.plant : '',
            activeName: 'first',
            units : [],

            latitude: -6.177531921860371,
            longitude: 106.83167662845935,

            stationid: '',
            storeid: '',
            cafeid: '',
            lpgid: '',

            costcenters: [],
            fuelcostcenters: [],
            nonfuelcostcenters: [],

            salestabshow: {
                fuel: true,
                store: true,
                cafe: true,
                lpg: true,
            },

            showchartfuel: false,
            showchartstore: false,
            showchartcafe: false,
            showchartproman: false,
            showchartplunit: false,
            showchartlpg: false,

            loading: {
                plant: false,
            },

            stationdetail: {},
            location: {},
            screenHeight: window.innerHeight - 160,
		}
	},
	watch:
	{
		//stationtype(){ this.resumePilihan() },
	}, 
    mounted()
    {
        //this.$emit('childrenRoute')
        this.getUnitByPlant();
        this.setDivHeight();
        this.addTabNavClass();
        window.addEventListener('resize', this.setDivHeight);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.setDivHeight);
    },
    methods:{
        setDivHeight() {
          this.screenHeight = window.innerHeight-160;
        },
        addTabNavClass() {
			$(".el-tabs__nav-wrap").addClass("bg-white");
			$(".el-tabs__header").addClass("bg-white");
		},

        async getUnitByPlant() {
			this.urlRequestParams=Config().apiURL
			this.urlRequestParams+='/v1/plant/getunitbyplant?'

			//this.urlRequestParams+='&type='+this.stationtype
			//this.urlRequestParams+='&area='+this.area
			//this.urlRequestParams+='&owner='+this.owner
			//this.urlRequestParams+='&station='+this.stationid
			this.urlRequestParams+='&plant='+this.plantno

			this.loading.plant = true;
			AxiosWithJar().get(this.urlRequestParams)
				.then((response)=>{ 
					this.reportdata = response.data;
                    this.units = response.data;

                    this.units.forEach((item) => {
                        this.ids.push(item.Id);
                        this.costcenters.push(item.CostCenter);
                        if(item.Type == 'BRIGHT') {
                            this.storeid = item.Id;
                            this.nonfuelcostcenters.push(item.CostCenter);
                        } else if(item.Type == 'CAFE') {
                            this.cafeid = item.Id;
                            this.nonfuelcostcenters.push(item.CostCenter);
                        } else if(item.Type == 'DC') {
                            this.lpgid = item.Id;
                            this.nonfuelcostcenters.push(item.CostCenter);
                        } else if(item.Type == 'BOM') {
                            this.lpgid = item.Id;
                            this.nonfuelcostcenters.push(item.CostCenter);
                        } else {
                            this.stationdetail = item;
                            this.stationid = item.Id;
                            this.fuelcostcenters.push(item.CostCenter);
                            let latitude = (item.Latitude).replace(/,/g, ".");
                            let longitude = (item.Longitude).replace(/,/g, ".");
                            this.latitude = parseFloat(latitude);
                            this.longitude = parseFloat(longitude);

                            this.location = { lat: this.latitude, lng: this.longitude };
                        }
                    });

                    if(this.storeid == '')
                        this.salestabshow.store = false;
                    if(this.cafeid == '')
                        this.salestabshow.cafe = false;
                    if(this.stationid == '')
                        this.salestabshow.fuel = false;
                    if(this.lpgid == '')
                        this.salestabshow.lpg = false;
				})
				.catch(error => {
					console.log(error)
					//this.errored = true
					//error.response.data
				})
				.finally(() => {
					this.loading.plant = false;
				})
        },

        handleTabClick(tab, event) {
            //console.log(tab, event);
            let tabIndex = tab.$vnode.key
            let tabName = tab.name
            let tabLabel = tab.label

            if(tabName == 'tab-sales-fuel') {
				this.showchartfuel = false
				setTimeout(() => {
					this.showchartfuel = true
				}, 500);
			} else if(tabName == 'tab-sales-store') {
				this.showchartstore = false
				setTimeout(() => {
					this.showchartstore = true
				}, 500);
			} else if(tabName == 'tab-sales-cafe') {
				this.showchartcafe = false
				setTimeout(() => {
					this.showchartcafe = true
				}, 500);
			} else if(tabName == 'tab-sales-property-management') {
				this.showchartproman = false
				setTimeout(() => {
					this.showchartproman = true
				}, 500);
			} else if(tabName == 'tab-pl-unit') {
				this.showchartplunit = false
                //console.log('this.showchartplunit before: ' + this.showchartplunit);
				setTimeout(() => {
					this.showchartplunit = true
                    //console.log('this.showchartplunit after: ' + this.showchartplunit);
				}, 500);
			} else if(tabName == 'tab-sales-lpg') {
				this.showchartlpg = false
                //console.log('this.showchartplunit before: ' + this.showchartplunit);
				setTimeout(() => {
					this.showchartlpg = true
                    //console.log('this.showchartplunit after: ' + this.showchartplunit);
				}, 500);
			}
        },
        applyFilter() {
			//this.resumePilihan()
        },

    }
}
</script>

<style>
.el-descriptions__header {
    margin-bottom: 8px !important;
}

.el-descriptions-item__label {
    width: 200px !important;
}


.tab-container-item {
    overflow-y: auto;
    overflow-x: hidden;
}
</style>